import PondMother from "@/model/pondmother";

class Pond {
  constructor() {
    this._id = "";
    this.assigned_schedule_id = null;
    this.center = null;
    this.created_at = "";
    this.cultivations = [];
    this.cultivation_date = null;
    this.feed_template_assigned = "";
    this.feed_type_id = "";
    this.geometry = { type: "", coordinates: [] };
    this.hasSchedule = false;
    this.hasTemplate = false;
    this.location_id = "";
    this.mode = [];
    this.pond_coordinates = [];
    this.pond_guards = [];
    this.pond_id = "";
    this.pond_mothers = [];
    this.post_larva_stocked = 0;
    this.managed_by = "MANUAL";
    this.shrimp_talks = [];
    this.size = "0";
    this.status = "INACTIVE";
    this.temperature = 0;
    this.timezone = { offSet: 0, name: "" };
    this.title = "Pond";
    this.units = "ha";
    this.updated_at = "";
    this.user_id = "";
  }

  castToPondObj(inputPondDetails) {
    if (typeof inputPondDetails === "string") {
      this._id = inputPondDetails;
    } else {
      Object.keys(inputPondDetails).forEach((key) => {
        if (key === "pond_mothers") {
          // console.log(this[key])
          this[key] = inputPondDetails[key].map((pm) => {
            const pmObj = new PondMother();
            pmObj.castToPMObj(pm);
            return pmObj;
          });
        } else {
          this[key] = inputPondDetails[key];
        }
      });
      this.pond_id = inputPondDetails._id;
      this.pond_coordinates = this.geometry.coordinates;
    }
  }

  getPondPropertiesObj() {
    const propertyNameList = [
      "title",
      "pond_id",
      "units",
      "location",
      "shrimp_talks",
      "pond_guards",
      "pond_mothers",
      "center",
    ];
    const properties = {};
    propertyNameList.forEach((property) => {
      properties[property] = this[property];
    });
    return properties;
  }

  static generateColorForMode(mode) {
    if (["SHRIMP_TALK", "AUTOMATIC"].indexOf(mode) > -1) {
      return { color: "#39cc64" };
    } else if (["HYBRID", "ALL_MODES", "MIXED"].indexOf(mode) > -1) {
      return { color: "#F9327A" };
    } else if (["FARMER", "SCHEDULE"].indexOf(mode) > -1) {
      return { color: "#F5A623" };
    } else if (["BASIC", "MANUAL"].indexOf(mode) > -1) {
      return { color: "#8c92ac" };
    } else if (mode === "NO_PMS") {
      return { color: "#000000" };
    }
  }
}

export default Pond;
